import React from 'react';
import { CAMPAIGN_TYPE_ID } from '@enums';

export const UNAVAILABLE_REASON = {
    EMPTY: 'empty',
    SYNCING: 'syncing'
};

// Why a campaign type block is shown but cannot be selected.
export const UNAVAILABLE_TOOLTIP = {
    [CAMPAIGN_TYPE_ID.BEST_SELLERS]: {
        [UNAVAILABLE_REASON.SYNCING]: {
            title: 'Unable to access My Best-sellers',
            text: "We're currently calculating your product sales and will grant access once it's done."
        }
    },
    [CAMPAIGN_TYPE_ID.SPECIFIC_COLLECTIONS]: {
        [UNAVAILABLE_REASON.SYNCING]: {
            title: 'Unable to access Specific Collections',
            text: "We're currently uploading your Collections from Shopify. It may take up to 24 hours"
        }
    },
    [CAMPAIGN_TYPE_ID.SPECIFIC_PRODUCT_TYPES]: {
        [UNAVAILABLE_REASON.SYNCING]: {
            title: 'Unable to access Specific Product Types',
            text: "We're currently uploading your Product Types from Shopify. It may take up to 24 hours"
        }
    }
};

export const PAGE = {
    TITLE: 'What products would you like to advertise?',
    DESCRIPTION: (
        <React.Fragment>
            Pick the type of products you&apos;d like to advertise. We recommend choosing your &apos;Entire
            catalog&apos;, but you can also select &apos;Best-sellers&apos;, &apos;Specific collections&apos;,
            &apos;Specific product types&apos;, or &apos;Specific products&apos;. For each of these campaign types,
            Klickly will automatically pull your products into an ad campaign and keep this campaign up-to-date based on
            changes to your catalog, best-sellers, collections, etc. And don&apos;t worry - you can review your choices
            on the next page.
        </React.Fragment>
    )
};
